import { render, staticRenderFns } from "./InstanceAppSettingsModal.vue?vue&type=template&id=4150bb7f&"
import script from "./InstanceAppSettingsModal.vue?vue&type=script&lang=js&"
export * from "./InstanceAppSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports